/**
 * Configuração vinda do build (Vite). Os valores reais são injetados pelo CI a partir
 * das saídas do CloudFormation — ver .github/workflows/implantar.yml.
 *
 * Nada aqui é segredo: id de pool e client id do Cognito são públicos por natureza em
 * uma SPA. Chave do Asaas e afins vivem no Secrets Manager, do lado do servidor.
 */
function exigir(nome: string, valor: string | undefined): string {
  if (!valor) {
    throw new Error(
      `Variável de build ausente: ${nome}. ` +
        'Copie apps/web/.env.example para .env.local e preencha com as saídas do CDK.',
    );
  }
  return valor;
}

export const configuracao = {
  urlDaApi: exigir('VITE_URL_API', import.meta.env.VITE_URL_API),
  cognito: {
    poolId: exigir('VITE_COGNITO_POOL_ID', import.meta.env.VITE_COGNITO_POOL_ID),
    clienteId: exigir('VITE_COGNITO_CLIENTE_ID', import.meta.env.VITE_COGNITO_CLIENTE_ID),
  },
  ambiente: import.meta.env.VITE_AMBIENTE ?? 'dev',
  /**
   * Tag que originou este deploy. Fica no rodapé para responder "o que está no ar agora?"
   * olhando a tela, sem depender de log de CI. Build local não tem tag: fica "local".
   */
  versao: import.meta.env.VITE_VERSAO || 'local',
} as const;
